import { render, staticRenderFns } from "./OrgPrompt.vue?vue&type=template&id=38e2e361&scoped=true"
import script from "./OrgPrompt.vue?vue&type=script&lang=js"
export * from "./OrgPrompt.vue?vue&type=script&lang=js"
import style0 from "./OrgPrompt.vue?vue&type=style&index=0&id=38e2e361&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2e361",
  null
  
)

export default component.exports